import PropTypes from 'prop-types';

import { StatusBadge } from '#/modules/commonComponents/badge';
import {
  formatRepairReportStatusLabel,
} from '#/modules/crmMgmt/aftersales/repairReport/helper/repairReportStatus';

const RepairReportStatusBadge = ({ status, size = 'default', className }) => (
  <StatusBadge
    status={status}
    label={formatRepairReportStatusLabel(status)}
    size={size}
    className={className}
  />
);

RepairReportStatusBadge.propTypes = {
  status: PropTypes.string,
  size: PropTypes.oneOf(['default', 'sm']),
  className: PropTypes.string,
};

export default RepairReportStatusBadge;
